import {StationDashboardModel} from '@/types/channel/station/station.model';
import {formatDateSafe, numberCommaString} from '@/utils/channel';
import React from 'react';
import {useStationData} from '@/stores/channel/station';
import {isValid} from 'date-fns';

interface BroadCastInfoProp {
  stationDashboard: StationDashboardModel;
}

const BroadCastInfo = ({stationDashboard}: BroadCastInfoProp) => {
  const {station} = useStationData();
  //방송국 개설일이 '2006.03.09'이전인 경우 '2006.03.09'로 표기하는 히스토리가 있음
  const getJoinedDate = () => {
    const joinedAt = station.detail?.joinedAt?.slice(0, 10);
    return joinedAt && joinedAt > '2006-03-09'
      ? joinedAt.replace(/-/g, '.')
      : '2006.03.09';
  };

  const BroadCastInfoData = [
    {
      label: '방송국 개설일',
      value: getJoinedDate(),
    },
    {
      label: '총 방송 시간',
      value: `${numberCommaString(Math.floor(stationDashboard.station.totalBroadcastTime! / 3600))}시간`,
    },
    {
      label: '누적 유저',
      value: `${numberCommaString(stationDashboard.upd.totalViewCount!)}명`,
    },
    {
      label: '누적 UP 수',
      value: numberCommaString(stationDashboard.upd.totalOkCount!),
    },
    {
      label: '오늘의 UP',
      value: numberCommaString(
        stationDashboard.upd[`today${station.detail?.activeNo}OkCount`]!,
      ),
    },
    {
      label: '누적 방문 수',
      value: numberCommaString(stationDashboard.upd.totalVisitCount!),
    },
    {
      label: '오늘 방문 수',
      value: numberCommaString(
        stationDashboard.upd[`today${station.detail?.activeNo}VisitCount`]!,
      ),
    },
    {
      label: '최근 방송일',
      value: station?.detail?.liveStartedAt
        ? `${formatDateSafe(station?.detail?.liveStartedAt, 'yyyy.MM.dd HH:mm')}`
        : '-',
    },
  ];
  return (
    <>
      <dl>
        <dt>방송 정보</dt>
        {BroadCastInfoData.map((item, index) => (
          <dd key={index}>
            <strong>{item.label}</strong>
            {item.value && (
              <b
                style={{textAlign: 'end'}}
                dangerouslySetInnerHTML={{__html: item.value}}
              />
            )}
          </dd>
        ))}
      </dl>
    </>
  );
};

export default BroadCastInfo;
